
import { createRouter, createWebHistory } from 'vue-router'
import axios from 'axios'

import Login from '@/components/auth/LoginPage.vue'
import UserDashboard from '@/views/UserDashboard.vue'
import AdminDashboard from '@/views/AdminDashboard.vue'
import DashboardUser from '@/components/DashboardUser.vue'
import DashboardAdmin from '@/components/DashboardAdmin.vue'
import GastoManager from '@/components/gastos/GastoManager.vue'
import ReceitasManager from '@/components/receitas/ReceitasManager.vue'
import DinheiroCofre from '@/components/cofre/DinheiroCofre.vue'
import SaldoBanco from '@/components/saldos/SaldoBanco.vue'
import RelatorioControl from '@/components/relatorio/RelatorioControl.vue'
import CalendarioPage from '@/components/calendario/CalendarioPage.vue'
import TarefasManeger from '@/components/tarefas/TarefasManeger.vue'
import UserForm from '@/components/users/UserForm.vue'
import EditUser from '@/components/users/EditUser.vue'
import MetasPage from '@/components/metas/MetasPage.vue'
import BlogPage from '@/components/blog/BlogPage.vue'
import GastoCard from '@/components/gastos/GastoCard.vue'
import ConsultaBolsa from '@/components/saldos/ConsultaBolsa.vue'
import CurrencyConverter from '@/components/conversor/CurrencyConverter.vue'
import CryptoTracker from '@/components/conversor/CryptoTracker.vue'
import CalculoPage from '@/components/conversor/CalculoPage.vue'
import AssinaturasPage from '@/components/assinaturas/AssinaturasPage.vue'
import CompleteSignup from '@/components/auth/CompleteSignup.vue'
import RegisterPage from '@/components/auth/RegisterPage.vue'
import ForgotPassword from '@/components/auth/ForgotPassword.vue'
import ResetPassword from '@/components/auth/ResetPassword.vue'
import RegisterAddress from '@/components/auth/RegisterAddress.vue'
import PainelFinanceiro from '@/views/PainelFinanceiro.vue'
import InvestimentosCompartilhadosPage from '@/components/investimentos/InvestimentosCompartilhadosPage.vue'
import MetasCompartilhadas from '@/components/metas/MetasCompartilhadas.vue'
import OrcamentoProjeto from '@/components/gastos/OrcamentoProjeto.vue'
import FinanciamentosPage from '@/components/gastos/FinanciamentosPage.vue'
import AssinaturasCompartilhadas from '@/components/assinaturas/AssinaturasCompartilhadas.vue'
import AssinaturaCompartilhadaFormView from '@/components/assinaturas/AssinaturaCompartilhadaFormView.vue'
import SubscriptionFormView from '@/components/assinaturas/SubscriptionFormView.vue'
import GastoFormView from '@/components/gastos/GastoFormView.vue'
import GastoCartaoFormView from '@/components/gastos/GastoCartaoFormView.vue'
import ReceitasFormView from '@/components/receitas/ReceitasFormView.vue'
import MetasFormView from '@/components/metas/MetasFormView.vue'
import MetasCompartilhadasFormView from '@/components/metas/MetasCompartilhadasFormView.vue'
import OrcamentoProjetoFormView from '@/components/gastos/OrcamentoProjetoFormView.vue'
import OrcamentoProjetoGastoFormView from '@/components/gastos/OrcamentoProjetoGastoFormView.vue'
import FinanciamentoFormView from '@/components/gastos/FinanciamentoFormView.vue'
import SaldoBancoFormView from '@/components/saldos/SaldoBancoFormView.vue'
import InvestimentosFormView from '@/components/investimentos/InvestimentosFormView.vue'
import InvestimentosCompartilhadosFormView from '@/components/investimentos/InvestimentosCompartilhadosFormView.vue'
import InvestimentoAtivoFormView from '@/components/investimentos/InvestimentoAtivoFormView.vue'
import TarefasFormView from '@/components/tarefas/TarefasFormView.vue'
import LandingPage from '@/views/LandingPage.vue'
import PlanosPage from '@/views/PlanosPage.vue'
import MinhaAssinaturaPage from '@/views/MinhaAssinaturaPage.vue'
import CheckoutSucesso from '@/views/CheckoutSucesso.vue'
import PrivacyPolicy from '@/views/PrivacyPolicy.vue'
import TermosDeUso from '@/views/TermosDeUso.vue'
import ExclusaoDeDados from '@/views/ExclusaoDeDados.vue'

const userChildren = [
  { path: 'dashboard', name: 'DashboardUser', component: DashboardUser },
  { path: 'minha-assinatura', name: 'MinhaAssinatura', component: MinhaAssinaturaPage },

  { path: 'gastos', name: 'GastosUser', component: GastoManager },
  { path: 'gastos/novo', name: 'GastoAdd', component: GastoFormView },
  { path: 'gastos/editar/:id', name: 'GastoEdit', component: GastoFormView, props: true },

  { path: 'gastos-cartao', name: 'GastosCartao', component: GastoCard },
  { path: 'gastos-cartao/novo', name: 'GastoCartaoAdd', component: GastoCartaoFormView },
  { path: 'gastos-cartao/editar/:id', name: 'GastoCartaoEdit', component: GastoCartaoFormView, props: true },

  { path: 'receitas', name: 'ReceitasUser', component: ReceitasManager },
  { path: 'receitas/nova', name: 'ReceitasAdd', component: ReceitasFormView },
  { path: 'receitas/editar/:id', name: 'ReceitasEdit', component: ReceitasFormView, props: true },

  { path: 'metas', name: 'MetasUser', component: MetasPage },
  { path: 'metas/nova', name: 'MetasAdd', component: MetasFormView },
  { path: 'metas/editar/:id', name: 'MetasEdit', component: MetasFormView, props: true },

  { path: 'dinheiro-cofre', name: 'CofreUser', component: DinheiroCofre },

  { path: 'saldo-banco', name: 'SaldoBancoUser', component: SaldoBanco },
  { path: 'saldo-banco/novo', name: 'SaldoBancoAdd', component: SaldoBancoFormView },
  { path: 'saldo-banco/editar/:id', name: 'SaldoBancoEdit', component: SaldoBancoFormView, props: true },

  { path: 'acoes', name: 'ConsultaBolsaUser', component: ConsultaBolsa },
  { path: 'relatorios', name: 'RelatoriosUser', component: RelatorioControl },
  { path: 'calendario', name: 'CalendarioUser', component: CalendarioPage },

  { path: 'tarefas', name: 'TarefasUser', component: TarefasManeger },
  { path: 'tarefas/nova', name: 'TarefasAdd', component: TarefasFormView },
  { path: 'tarefas/editar/:id', name: 'TarefasEdit', component: TarefasFormView, props: true },

  { path: 'editar-perfil', name: 'EditarPerfilUser', component: EditUser },
  { path: 'blog', name: 'BlogUser', component: BlogPage },

  { path: 'conversor', name: 'ConversorMoedas', component: CurrencyConverter },
  { path: 'cripto', name: 'CriptoMoedas', component: CryptoTracker },
  { path: 'calculadora', name: 'Calculadora', component: CalculoPage },

  { path: 'assinaturas', name: 'AssinaturasUser', component: AssinaturasPage },
  { path: 'assinaturas/nova', name: 'SubscriptionAdd', component: SubscriptionFormView },
  { path: 'assinaturas/editar/:id', name: 'SubscriptionEdit', component: SubscriptionFormView, props: true },

  {
    path: 'assinaturas-compartilhadas/:id?',
    name: 'AssinaturasCompartilhadasUser',
    component: AssinaturasCompartilhadas,
    props: true
  },
  {
    path: 'assinaturas-compartilhadas/novo',
    name: 'AssinaturaCompartilhadaAdd',
    component: AssinaturaCompartilhadaFormView
  },
  {
    path: 'assinaturas-compartilhadas/:uuid/editar',
    name: 'AssinaturaCompartilhadaEdit',
    component: AssinaturaCompartilhadaFormView,
    props: true
  },

  { path: 'investimentos', name: 'InvestimentosUser', component: PainelFinanceiro },
  { path: 'investimentos/novo', name: 'InvestimentosAdd', component: InvestimentosFormView },
  { path: 'investimentos/editar/:id', name: 'InvestimentosEdit', component: InvestimentosFormView, props: true },

  {
    path: 'investimentos-compartilhados/:id?',
    name: 'InvestimentosCompartilhados',
    component: InvestimentosCompartilhadosPage,
    props: true
  },
  {
    path: 'investimentos-compartilhados/novo',
    name: 'InvestimentosCompartilhadosAdd',
    component: InvestimentosCompartilhadosFormView
  },
  {
    path: 'investimentos-compartilhados/:uuid/editar',
    name: 'InvestimentosCompartilhadosEdit',
    component: InvestimentosCompartilhadosFormView,
    props: true
  },
  {
    path: 'investimentos-compartilhados/:portfolioUuid/ativos/novo',
    name: 'InvestimentoAtivoAdd',
    component: InvestimentoAtivoFormView,
    props: true
  },
  {
    path: 'investimentos-compartilhados/ativos/editar/:ativoId',
    name: 'InvestimentoAtivoEdit',
    component: InvestimentoAtivoFormView,
    props: true
  },

  {
    path: 'metas-compartilhadas/:id?',
    name: 'MetasCompartilhadas',
    component: MetasCompartilhadas,
    props: true
  },
  {
    path: 'metas-compartilhadas/novo',
    name: 'MetasCompartilhadasAdd',
    component: MetasCompartilhadasFormView
  },
  {
    path: 'metas-compartilhadas/:uuid/editar',
    name: 'MetasCompartilhadasEdit',
    component: MetasCompartilhadasFormView,
    props: true
  },

  {
    path: 'orcamento-projeto/:id?',
    name: 'OrcamentoProjeto',
    component: OrcamentoProjeto,
    props: true
  },
  {
    path: 'orcamento-projeto/novo',
    name: 'OrcamentoProjetoAdd',
    component: OrcamentoProjetoFormView
  },
  {
    path: 'orcamento-projeto/:uuid/editar',
    name: 'OrcamentoProjetoEdit',
    component: OrcamentoProjetoFormView,
    props: true
  },
  {
    path: 'orcamento-projeto/:orcamentoUuid/gastos/novo',
    name: 'OrcamentoProjetoGastoAdd',
    component: OrcamentoProjetoGastoFormView,
    props: true
  },
  {
    path: 'orcamento-projeto/:orcamentoUuid/gastos/:gastoId/editar',
    name: 'OrcamentoProjetoGastoEdit',
    component: OrcamentoProjetoGastoFormView,
    props: true
  },

  {
    path: 'financiamentos/:financiamentoId?',
    name: 'FinanciamentosUser',
    component: FinanciamentosPage,
    props: true
  },
  {
    path: 'financiamentos/novo',
    name: 'FinanciamentoAdd',
    component: FinanciamentoFormView
  },
  {
    path: 'financiamentos/:financiamentoId/editar',
    name: 'FinanciamentoEdit',
    component: FinanciamentoFormView,
    props: true
  }
]

const adminChildren = [
  { path: 'dashboard', name: 'DashboardAdmin', component: DashboardAdmin },
  { path: 'usuarios', name: 'UsuariosAdmin', component: UserForm }
]

const routes = [
  { path: '/', name: 'Home', component: LandingPage },

  { path: '/login', name: 'Login', component: Login },
  { path: '/complete-signup', name: 'CompleteSignup', component: CompleteSignup },
  { path: '/forgot-password', name: 'ForgotPassword', component: ForgotPassword },
  { path: '/reset-password', name: 'ResetPassword', component: ResetPassword },
  { path: '/register', name: 'Register', component: RegisterPage },
  { path: '/register/address/:userId', name: 'RegisterAddress', component: RegisterAddress },

  { path: '/planos', name: 'Planos', component: PlanosPage },
  { path: '/checkout/sucesso', name: 'CheckoutSucesso', component: CheckoutSucesso },

  {
    path: '/politica-de-privacidade',
    alias: '/privacidade',
    name: 'Privacidade',
    component: PrivacyPolicy
  },
  {
    path: '/termos-de-uso',
    name: 'TermosDeUso',
    component: TermosDeUso
  },
  {
    path: '/exclusao-de-dados',
    name: 'ExclusaoDeDados',
    component: ExclusaoDeDados
  },

  {
    path: '/user',
    component: UserDashboard,
    meta: {
      requiresAuth: true,
      role: 'ROLE_USER'
    },
    children: userChildren
  },
  {
    path: '/admin',
    component: AdminDashboard,
    meta: {
      requiresAuth: true,
      role: 'ROLE_ADMIN'
    },
    children: adminChildren
  }
]

export const router = createRouter({
  history: createWebHistory('/'),
  routes
})

let cacheAssinatura = null
let cacheExpira = 0
let cacheToken = null

async function getAssinaturaStatus(token) {
  const agora = Date.now()

  if (
    cacheToken === token &&
    cacheAssinatura &&
    agora < cacheExpira
  ) {
    return cacheAssinatura
  }

  cacheToken = token
  cacheAssinatura = null
  cacheExpira = 0

  try {
    const res = await axios.get(
      'https://backend.controlease.com.br/api/billing/status',
      {
        headers: {
          Authorization: `Bearer ${token}`
        },
        timeout: 10000
      }
    )

    const status = {
      hasActive: res.data?.hasActive === true,
      canTrial: res.data?.canTrial === true
    }

    cacheAssinatura = status
    cacheExpira = Date.now() + 15000

    return status
  } catch (error) {
    if (
      error.response?.status === 401 ||
      error.response?.status === 403
    ) {
      return {
        hasActive: false,
        canTrial: false,
        authError: true
      }
    }

    return {
      hasActive: false,
      canTrial: false,
      unavailable: true
    }
  }
}

router.beforeEach(async (to) => {
  const token = localStorage.getItem('token')
  const role = localStorage.getItem('role')

  if (
    to.matched.some(route => route.meta.requiresAuth) &&
    !token
  ) {
    return { name: 'Login' }
  }

  const requiredRoleRoute = to.matched.find(
    route => route.meta?.role
  )

  const requiredRole = requiredRoleRoute?.meta.role

  if (requiredRole && role !== requiredRole) {
    if (role === 'ROLE_ADMIN') {
      return { name: 'DashboardAdmin' }
    }

    if (role === 'ROLE_USER') {
      return { name: 'DashboardUser' }
    }

    return { name: 'Login' }
  }

  const areaUsuario = to.matched.some(
    route => route.path === '/user'
  )

  const paginaDeAssinatura = to.name === 'MinhaAssinatura'

  if (
    areaUsuario &&
    role === 'ROLE_USER' &&
    !paginaDeAssinatura
  ) {
    const assinatura = await getAssinaturaStatus(token)

    if (assinatura.authError) {
      return { name: 'Login' }
    }

    if (assinatura.unavailable) {
      return {
        name: 'Planos',
        query: { status: 'indisponivel' }
      }
    }

    if (!assinatura.hasActive) {
      return { name: 'Planos' }
    }
  }

  return true
})

export default router
